import type {ThunkAction} from 'src/reducers';
import type {RawQuery} from 'src/utils/redux-api';
import type {EngagementCohorts} from 'src/types/engagement-cohorts';

import {thunkify as flow} from 'src/utils/thunks';
import {camel} from 'src/utils';
import {key, cached, fetching} from 'src/utils/redux';
import * as reduxApi from 'src/utils/redux-api';
import {resolveAnalyticsQuery} from 'src/utils/analytics-query';


const {stringify} = JSON;

export const RECEIVE = 'engagementCohorts/receive';

export type EngagementCohortsAction = {
  type: 'engagementCohorts/receive';
  payload: {
    data: EngagementCohorts;
    splitBy: string;
  };
};

const receive = (data: EngagementCohorts, splitBy: string) => ({
  type: RECEIVE,
  payload: {
    data,
    splitBy,
  },
});

const querying =
  () =>
  (func: any) =>
  // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
  (...args) => {
    const lastIndex = args.length - 1;
    args[lastIndex] = resolveAnalyticsQuery(args[lastIndex], [
      'client',
      'event_types',
      'recipients',
      'sort',
    ]);
    return func(...args);
  };

export const getEngagementCohorts: (
  splitBy: string,
  query: RawQuery,
) => ThunkAction<unknown> = flow(
  querying(),
  key(
    (splitBy: string, query: RawQuery) =>
      `engagementCohorts:${splitBy}:${stringify(query)}`,
  ),
  // @ts-expect-error - TS7006 - Parameter 'json' implicitly has an 'any' type.
  cached((json, splitBy: string) => receive(camel(json), splitBy), {
    // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'hash' does not exist in type '{ ttl?: number | undefined; cacheSet?: ((key: unknown, timestamp: number | undefined, queryHash: unknown) => { type: string; payload: { key: unknown; timestamp: number; queryHash: unknown; }; }) | undefined; cacheHit?: ((key: unknown, ttl: unknown, queryHash: unknown) => { ...; }) | undefined; cacheMiss?: ((key: unk...'.
    hash: (splitBy: string, query: RawQuery) =>
      `engagementCohorts:${splitBy}:${stringify(query)}`,
  }),
  fetching(),
)((splitBy: string, query: RawQuery) =>
  reduxApi.post(`analytics/engagement/cohorts`, {
    ...query,
    split_by: {attributes: [splitBy]},
  }),
);
